module.exports = __webpack_public_path__ + "img/tt.ee4a6190.png";